var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useState } from 'react';
import { TranslateTextDropdownButton } from 'components/translateTextDropdownButton';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { ConversationContext } from '../ConversationProvider';
import TextMessage from './TextMessage';
import { getAttachment } from './utils/attachment';
export const MessageWhatsApp = (_a) => {
    var { message, markup } = _a, otherProps = __rest(_a, ["message", "markup"]);
    const { agentCopilot } = useFeatureFlag(['agent-copilot']);
    const [renderedMessage, setRenderedMessage] = useState(message);
    const [isTranslated, setIsTranslated] = useState(false);
    const { translationLanguageCode } = useContext(ConversationContext);
    const [selectedLanguageCode, setSelectedLanguageCode] = useState();
    useEffect(() => {
        setSelectedLanguageCode(translationLanguageCode);
    }, [translationLanguageCode]);
    const gutterButtons = useMemo(() => {
        if (!agentCopilot || !message.text) {
            return undefined;
        }
        return (_jsx(TranslateTextDropdownButton, { message: message.text, selectedLanguageCode: selectedLanguageCode, onTranslateEnd: (event) => {
                setRenderedMessage((message) => (Object.assign(Object.assign({}, message), { text: event.translatedText })));
                setIsTranslated(true);
            }, onTranslateError: () => {
                setIsTranslated(false);
            }, onRevert: () => {
                setRenderedMessage(message);
                setIsTranslated(false);
            } }));
    }, [agentCopilot, message, selectedLanguageCode]);
    const attachment = useMemo(() => getAttachment(message, { scaleImage: true }), [message]);
    return (_jsx(TextMessage, Object.assign({}, otherProps, { message: renderedMessage, content: attachment, gutterButtons: gutterButtons, isTranslated: isTranslated })));
};
